import { render, staticRenderFns } from "./opname.vue?vue&type=template&id=786a4054"
import script from "./opname.vue?vue&type=script&lang=js"
export * from "./opname.vue?vue&type=script&lang=js"
import style0 from "./opname.vue?vue&type=style&index=0&id=786a4054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports